<template>
    <div id="storeadd">
       <HeaderNav :is_dialogpage="true" :routername="this.$route.name" :addoredirtname="addoredirtname"></HeaderNav>
       
       <div class="store-form-page">
           <!-- 基本信息卡片 -->
           <div class="form-card">
               <div class="card-header">
                   <span class="card-icon">&#127968;</span>
                   <h3>基本信息</h3>
               </div>
               <div class="card-body">
                   <div class="form-row">
                       <div class="form-group">
                           <label><i class="required">*</i>酒店名称</label>
                           <input placeholder="请输入酒店名称" v-model="formData.storeName" />
                       </div>
                       <div class="form-group">
                           <label><i class="required">*</i>酒店类型</label>
                           <select v-model="formData.storeType">
                               <option value="" disabled>请选择酒店类型</option>
                               <option v-for="item in hotelTypeOptions" :key="item.storeType" :value="item.storeType">
                                   {{ item.storeTypeName }}
                               </option>
                           </select>
                       </div>
                   </div>
                   <div class="form-row">
                       <div class="form-group full-width">
                           <label><i class="required">*</i>酒店地址</label>
                           <input placeholder="请输入酒店地址(省、市、县/区、街道/镇、门牌号)" v-model="formData.address" />
                       </div>
                   </div>
                   <div class="form-row">
                       <div class="form-group">
                           <label><i class="required">*</i>酒店电话</label>
                           <input placeholder="请输入联系电话" v-model="formData.storeTel" />
                       </div>
                       <div class="form-group">
                           <label><i class="required">*</i>统一社会信用代码</label>
                           <input placeholder="请输入统一社会信用代码" v-model="formData.storeIcNo" />
                       </div>
                   </div>
               </div>
           </div>

           <!-- 法人信息卡片 -->
           <div class="form-card">
               <div class="card-header">
                   <span class="card-icon">&#128100;</span>
                   <h3>法人信息</h3>
               </div>
               <div class="card-body">
                   <div class="form-row">
                       <div class="form-group">
                           <label><i class="required">*</i>法人姓名</label>
                           <input placeholder="请输入法人姓名" v-model="formData.storeLegeName" />
                       </div>
                       <div class="form-group">
                           <label><i class="required">*</i>法人手机号</label>
                           <input placeholder="请输入法人手机号" v-model="formData.storeLegeMobile" />
                       </div>
                   </div>
                   <div class="form-row">
                       <div class="form-group">
                           <label><i class="required">*</i>法人身份证号</label>
                           <input placeholder="请输入法人身份证号" v-model="formData.storeLegeIdCard" />
                       </div>
                   </div>
                   <div class="form-row">
                       <div class="form-group">
                           <label><i class="required">*</i>营业执照</label>
                           <div class="pic-upload-box">
                               <div class="pic-item" v-if="!formData.businessLicenseFront">
                                   <PicInput v-model="formData.businessLicenseFront" :inputid="'f1'"/>
                               </div>
                               <div class="pic-preview" v-if="formData.businessLicenseFront">
                                   <a href="javascript:void(0)" class="pic-del" @click="deletepic(1)">&times;</a>
                                   <img :src="formData.businessLicenseFront.fileFullPath" @click="showimg(formData.businessLicenseFront.fileFullPath)">
                               </div>
                           </div>
                       </div>
                   </div>
                   <div class="form-row">
                       <div class="form-group">
                           <label><i class="required">*</i>身份证照片</label>
                           <div class="pic-upload-row">
                               <div class="pic-upload-item">
                                   <span class="pic-sub-label">正面</span>
                                   <div class="pic-item" v-if="!formData.icpicFront">
                                       <PicInput v-model="formData.icpicFront" :inputid="'f2'"/>
                                   </div>
                                   <div class="pic-preview" v-if="formData.icpicFront">
                                       <a href="javascript:void(0)" class="pic-del" @click="deletepic(2)">&times;</a>
                                       <img :src="formData.icpicFront.fileFullPath" @click="showimg(formData.icpicFront.fileFullPath)">
                                   </div>
                               </div>
                               <div class="pic-upload-item">
                                   <span class="pic-sub-label">反面</span>
                                   <div class="pic-item" v-if="!formData.icpicBack">
                                       <PicInput v-model="formData.icpicBack" :inputid="'f3'"/>
                                   </div>
                                   <div class="pic-preview" v-if="formData.icpicBack">
                                       <a href="javascript:void(0)" class="pic-del" @click="deletepic(3)">&times;</a>
                                       <img :src="formData.icpicBack.fileFullPath" @click="showimg(formData.icpicBack.fileFullPath)">
                                   </div>
                               </div>
                           </div>
                       </div>
                   </div>
               </div>
           </div>

           <!-- 酒店详情卡片 -->
           <div class="form-card">
               <div class="card-header">
                   <span class="card-icon">&#128196;</span>
                   <h3>酒店详情</h3>
               </div>
               <div class="card-body">
                   <div class="form-row vertical">
                       <div class="form-group full-width">
                           <label>酒店设施</label>
                           <textarea placeholder="请输入酒店设施" v-model="formData.storePlan"></textarea>
                       </div>
                   </div>
                   <div class="form-row vertical">
                       <div class="form-group full-width">
                           <label>服务项目</label>
                           <textarea placeholder="请输入服务项目" v-model="formData.storeServer"></textarea>
                       </div>
                   </div>
                   <div class="form-row vertical">
                       <div class="form-group full-width">
                           <label>预约说明</label>
                           <textarea placeholder="请输入预约说明" v-model="formData.storeReservation"></textarea>
                       </div>
                   </div>
                   <div class="form-row vertical">
                       <div class="form-group full-width">
                           <label>酒店详情介绍</label>
                           <div class="editor-container">
                                <Toolbar
                                    style="border-bottom: 1px solid #eee"
                                    :editor="editorRef"
                                    :defaultConfig="toolbarConfig"
                                    :mode="mode"
                                />
                                <Editor
                                    style="height: 400px; overflow-y: hidden;"
                                    v-model="formData.storeDesc"
                                    :defaultConfig="editorConfig"
                                    :mode="mode"
                                    @onCreated="handleCreated"
                                />
                           </div>
                       </div>
                   </div>
               </div>
           </div>

           <!-- 底部按钮 -->
           <div class="form-footer">
               <a href="javascript:void(0)" class="btn-cancel" @click="closePage(0)">取消</a>
               <a href="javascript:void(0)" class="btn-submit" @click="handleSubmit">提交</a>
           </div>
       </div>
   </div>
   <AddressCheck v-if="is_show_addr" v-model="this.formData.address" @closedig="this.closeDig()"></AddressCheck>
   <div id="showimgbox" v-if="this.showimg_src" @click.self="this.closeshowimgbox">
         <a href="javascript:void(0);" @click="this.closeshowimgbox">关闭</a>
         <img :src="this.showimg_src" @load="loadimgfun" ref="imageElement" :style="{width:this.show_img_width+'px',
            height:this.show_img_height+'px',marginTop:(0-(this.show_img_height/2))+'px',marginLeft:(0-(this.show_img_width/2))+'px'}"></img>
   </div>
</template>

<script>
import HeaderNav from '../common/HeaderNav.vue';
import { ElMessage } from 'element-plus';
import '@wangeditor/editor/dist/css/style.css' // 引入 css
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
import http from '@/tools/Http';
// 请根据实际项目 API 文件路径引入对应的接口
import { selectStoreType,updateStoreInfo, selectStoreInfo } from '@/tools/Api';
import AddressCheck from '../common/AddressCheck.vue';
import PicInput from '../common/PicInput.vue';

export default {
   name: "StoreEdirt",
   data() {
       return {
           addoredirtname: "",
           is_read:true,
           is_show_addr: false,
           showimg_src: "",
           is_showimg_box:true,
           show_img_width: 0,
           show_img_height: 0,
           store_id: '',
           hotelTypeOptions:[],//酒店类型
           
           // 表单数据对象
          formData: {
                storeName: "",//酒店名称
                storeIcNo: "",//社会信用码
                address: "",//酒店地址
                storeDesc: "", //酒店描述
                storeTel: "",//酒店电话
                storeLegeName:"", //法人姓名
                storeLegeIdCard: "",//法人身份证号 
                storeLegeMobile: "",//法人手机号
                storePlan:"",//酒店设施
                storeServer:"",//服务项目
                storeReservation:"",//预约说明
                businessLicenseFront: "", //营业执照
                icpicFront: "",//身份证正面
                icpicBack: "", //身份证反面
                storeType: "",//酒店类型
           },
           // --- 富文本相关 ---
           editorRef: null, // 编辑器实例，必须用 null 初始化
           mode: 'default', // 或 'simple'
           toolbarConfig: {
               // 排除某些菜单，例如视频
               excludeKeys: ['insertVideo', 'uploadVideo'], 
           },
           editorConfig: {
               placeholder: '请输入酒店详细介绍...',
               MENU_CONF: {
                    uploadImage: {
                        // 自定义上传
                        customUpload: async (file, insertFn) => {
                            // file 是选中的文件
                            const formData = new FormData()
                            formData.append('file', file)
                            
                            try {
                                // 调用后端上传接口
                                const res = await this.uploadImageToServer(formData)
                                // 插入图片
                                insertFn(res.fileFullPath, '', '')
                            } catch (error) {
                                console.error('上传失败', error)
                            }
                        }
                    }
                }
            }
       };
   },
   components: {
       HeaderNav,
       Editor,
       Toolbar,
       AddressCheck,
       PicInput
   },
   props: {
       is_edirt: {
           type: Boolean,
           required: false
       }
   },
   mounted() {
        this.getHotolTypeList()

       if (this.is_edirt) {
           this.addoredirtname = "修改";
           this.getStoreInfo();
       } else {
           this.addoredirtname = "新增";
       }
      
   },
   beforeUnmount() {
       // 组件销毁时，及时销毁编辑器
       const editor = this.editorRef
       if (editor == null) return
       editor.destroy()
   },
   methods: {
    getHotolTypeList(){
        selectStoreType().then(res=>{
                    if(res.status==0){
                        if(res.data.length>0){
                            this.hotelTypeOptions=res.data
                        }
                    }else{
                        ElMessage({
                           message:"获取酒店类型失败！", 
                           type:'error', 
                           duration:1500
                        })
                    }
                    
                }).catch(error=>{
                    ElMessage({
                           message:"请求失败！", 
                           type:'error', 
                           duration:1500
                        })
                })

    },
    closeshowimgbox(){
        this.showimg_src=""
        this.show_img_width=0
        this.show_img_height=0
    },
    async loadimgfun(){
        
        let w=0
        let h=0
        if(w>h){ 
             this.show_img_width=600;
             this.show_img_height=Math.round(w/600*h);
        }else{
             this.show_img_height=600;
             this.show_img_width=Math.round(h/600*w);
        }
         const img = new Image()
      img.src = this.showimg_src
      await new Promise((resolve) => {
        img.onload = () => {
        
         w= img.width
         h= img.height
         if(w>h){ 
             this.show_img_width=600;
             this.show_img_height=Math.round(600/w*h);
        }else{
             this.show_img_height=600;
             this.show_img_width=Math.round(600/h*w);
        }
        console.log(this.show_img_width)
          resolve()
        }
      })
    },
    deletepic(index){
            if(index==1){
                this.formData.businessLicenseFront=''
            }else if(index==2){
                this.formData.icpicFront=''
            }else if(index==3){ 
                this.formData.icpicBack=''
            }
    },
    showimg(src){
        this.showimg_src=src;
    },
    showAddressCheck() {
         this.is_show_addr=true
     },
     closeDig(){
         this.is_show_addr=false
     },
        async uploadImageToServer (formData) { 
                 const date=await  http.post('/file/uplaods',formData,{
                                headers:{
                                    'Content-Type':'multipart/form-data'
                                },
                                onUploadProgress:progressEvent=>{
                     
                                }
                        }).then(res=>{
                            if(res.status==0){
                                return res.data
                            }else{ 
                            }
                        }).catch(error=>{
                        })
                        return date
        },
       // 编辑器创建回调
       handleCreated(editor) {
           
           this.editorRef = editor;
        //    this.editorRef.disable()
           
       },

       // 关闭弹窗
       closePage(isrush) {
           // 重置表单
           this.resetForm();
           if (isrush == 1) {
               this.$emit('closerush');
           } else {
               this.$emit('closepage');
           }
       },

       // 获取详情用于编辑
       getStoreInfo() {
               selectStoreInfo().then(res => {
               if (res.status == 0) {
                   const data = res.data;
                //    const storeCoordinates=data.storeCoordinates
                //    const coordArr=storeCoordinates.split(",")
                   this.formData = {
                    storeName: data.storeName,//酒店名称
                    storeIcNo: data.storeIcNo,//社会信用码
                    address: data.storeAddr,//酒店地址
                    storeDesc: data.storeDesc, //酒店描述
                    storeTel: data.storeTel,//酒店电话
                    storeLegeName:data.storeLegeName, //法人姓名
                    storeLegeIdCard: data.storeLegeNo,//法人身份证号 
                    storeLegeMobile: data.storeLegePhone,//法人手机号
                    storePlan:data.storePlan,//酒店设施
                    storeServer:data.storeServer,//服务项目
                    storeReservation:data.storeReservation,//预约说明
                    businessLicenseFront: {
                        fileFullPath:data.storeIcSrc
                    }, //营业执照
                    icpicFront: {
                        fileFullPath:data.storeLegIc1Src
                    },//身份证正面
                    icpicBack: {
                        fileFullPath:data.storeLegIc2Src
                    }, //身份证反面
                    storeType: data.storeType,//酒店类型
                   }
                   this.store_id=data.storeId

               } else {
                   ElMessage({
                       message: res.msg || "获取详情失败",
                       type: 'error',
                       duration: 1500
                   });
               }
           }).catch(err => {
               ElMessage({
                   message: "请求失败！",
                   type: 'error',
                   duration: 1500
               });
           });
       },

       // 提交处理
       handleSubmit() {
           if (!this.checkInput()) {
               return;
           }
           const params = {
            storeName: this.formData.storeName,
            storeAddr: this.formData.address,
            storeIcNo: this.formData.storeIcNo,
            storeType: this.formData.storeType,
            storeLegeName:this.formData.storeLegeName,
            storeLegeNo: this.formData.storeLegeIdCard,
            storeLegePhone: this.formData.storeLegeMobile,
            storeTel: this.formData.storeTel,
            storeIcSrc: this.formData.businessLicenseFront.fileFullPath,
            storeLegIc1Src: this.formData.icpicFront.fileFullPath,
            storeLegIc2Src: this.formData.icpicBack.fileFullPath,
            storeDesc: this.formData.storeDesc,
            storePlan:this.formData.storePlan,
            storeReservation:this.formData.storeServer,
            storeServer:this.formData.storeReservation
           };

           // 如果是编辑模式，通常需要带上 ID
           if (this.is_edirt) {
               params.storeId = this.store_id; 
           }

           const apiCall = this.is_edirt ? updateStoreInfo(params) : addStore(params);

           apiCall.then(res => {
               if (res.status == 0) {
                   ElMessage({
                       message: "修改成功！" ,
                       type: 'success',
                       duration: 1500
                   });
                   this.closePage(1); // 1 表示刷新列表
               } else {
                   ElMessage({
                       message: res.msg || "操作失败",
                       type: 'error',
                       duration: 1500
                   });
               }
           }).catch(err => {
               ElMessage({
                   message: "请求失败！",
                   type: 'error',
                   duration: 1500
               });
           });
       },

             // 表单验证
        checkInput() {
           if (!this.formData.storeName || this.formData.storeName.trim().length < 1) {
               ElMessage({ message: "酒店名称不能为空！", type: 'error', duration: 1500 });
               return false;
           }
           if (!this.formData.storeType) {
               ElMessage({ message: "请选择酒店类型！", type: 'error', duration: 1500 });
               return false;
           }
           if (!this.formData.storeTel || this.formData.storeTel.trim().length < 1) {
               ElMessage({ message: "酒店电话不能为空！", type: 'error', duration: 1500 });
               return false;
           }
           if (!this.formData.storeIcNo || this.formData.storeIcNo.trim().length < 1) {
               ElMessage({ message: "统一社会信用代码不能为空！", type: 'error', duration: 1500 });
               return false;
           }
           if (!this.formData.businessLicenseFront) {
               ElMessage({ message: "请上传营业执照！", type: 'error', duration: 1500 });
               return false;
           }
           if (!this.formData.storeLegeMobile || this.formData.storeLegeMobile.trim().length < 1) {
               ElMessage({ message: "法人手机号不能为空！", type: 'error', duration: 1500 });
               return false;
           }
           // 简单的手机号格式校验
           if (!/^1[3-9]\d{9}$/.test(this.formData.storeLegeMobile)) {
               ElMessage({ message: "法人手机号格式不正确！", type: 'error', duration: 1500 });
               return false;
           }
           if (!this.formData.storeLegeName || this.formData.storeLegeName.trim().length < 1) {
               ElMessage({ message: "法人姓名不能为空！", type: 'error', duration: 1500 });
               return false;
           }
           
           if (!this.formData.storeLegeIdCard || this.formData.storeLegeIdCard.trim().length < 1) {
               ElMessage({ message: "法人身份证号不能为空！", type: 'error', duration: 1500 });
               return false;
           }
           if (!this.formData.icpicFront) {
               ElMessage({ message: "请上传身份证正面照片！", type: 'error', duration: 1500 });
               return false;
           }
           if (!this.formData.icpicBack) {
               ElMessage({ message: "请上传身份证反面照片！", type: 'error', duration: 1500 });
               return false;
           }
           if (!this.formData.address) {
               ElMessage({ message: "请正确输入酒店地址！", type: 'error', duration: 1500 });
               return false;
           }
           
           return true;
       },

       // 重置表单
       resetForm() {
           this.formData = {
                storeName: "",//酒店名称
                storeIcNo: "",//社会信用码
                address: "",//酒店地址
                storeDesc: "", //酒店描述
                storeTel: "",//酒店电话
                storeLegeName:"", //法人姓名
                storeLegeIdCard: "",//法人身份证号 
                storeLegeMobile: "",//法人手机号
                storePlan:"",//酒店设施
                storeServer:"",//服务项目
                storeReservation:"",//预约说明
                businessLicenseFront: "", //营业执照
                icpicFront: "",//身份证正面
                icpicBack: "", //身份证反面
                storeType: "",//酒店类型
           };
       }
    }
};
</script>

<style scoped>
#storeadd {
   width: 100%;
   height: 100%;
   position: absolute;
   background-color: #f5f6f8;
   left: 0;
   top: 0;
   z-index: 20;
}

.store-form-page {
   width: 100%;
   height: calc(100% - 40px);
   float: left;
   padding: 24px 40px;
   overflow-y: auto;
   box-sizing: border-box;
}

/* 表单卡片 */
.form-card {
   background: #fff;
   border-radius: 10px;
   margin-bottom: 20px;
   box-shadow: 0 2px 12px rgba(0,0,0,0.06);
   overflow: hidden;
}
.card-header {
   display: flex;
   align-items: center;
   gap: 10px;
   padding: 16px 28px;
   border-bottom: 1px solid #f0f0f0;
   background: #fafbfc;
}
.card-header h3 {
   margin: 0;
   font-size: 16px;
   color: #333;
   font-weight: 600;
}
.card-icon {
   font-size: 20px;
}
.card-body {
   padding: 24px 28px;
}

/* 表单行 */
.form-row {
   display: flex;
   gap: 24px;
   margin-bottom: 20px;
}
.form-row:last-child {
   margin-bottom: 0;
}
.form-row.vertical {
   flex-direction: column;
}
.form-group {
   flex: 1;
   display: flex;
   flex-direction: column;
   gap: 8px;
}
.form-group.full-width {
   flex: none;
   width: 100%;
}
.form-group label {
   font-size: 14px;
   color: #555;
   font-weight: 500;
}
.form-group label .required {
   color: #e57834;
   font-style: normal;
   margin-right: 3px;
}
.form-group input,
.form-group select {
   height: 42px;
   border: 1px solid #dcdfe6;
   border-radius: 6px;
   outline: none;
   font-size: 14px;
   padding: 0 12px;
   color: #333;
   transition: border-color 0.2s, box-shadow 0.2s;
   background-color: #fff;
}
.form-group input:focus,
.form-group select:focus {
   border-color: #e57834;
   box-shadow: 0 0 0 3px rgba(229,120,52,0.1);
}
.form-group input::placeholder {
   color: #bbb;
}
.form-group textarea {
   width: 100%;
   min-height: 90px;
   border: 1px solid #dcdfe6;
   border-radius: 6px;
   outline: none;
   font-size: 14px;
   padding: 10px 12px;
   color: #333;
   resize: vertical;
   font-family: inherit;
   transition: border-color 0.2s, box-shadow 0.2s;
   box-sizing: border-box;
}
.form-group textarea:focus {
   border-color: #e57834;
   box-shadow: 0 0 0 3px rgba(229,120,52,0.1);
}

/* 图片上传 */
.pic-upload-box {
   display: flex;
   align-items: center;
   gap: 16px;
}
.pic-upload-row {
   display: flex;
   gap: 24px;
}
.pic-upload-item {
   display: flex;
   flex-direction: column;
   gap: 8px;
}
.pic-sub-label {
   font-size: 13px;
   color: #888;
}
.pic-item {
   width: 130px;
   height: 100px;
}
.pic-preview {
   width: 130px;
   height: 100px;
   border-radius: 8px;
   overflow: hidden;
   position: relative;
   border: 1px solid #eaeaea;
   cursor: pointer;
   transition: all 0.3s;
}
.pic-preview:hover {
   box-shadow: 0 4px 16px rgba(0,0,0,0.12);
   transform: translateY(-2px);
}
.pic-preview img {
   width: 100%;
   height: 100%;
   object-fit: cover;
}
.pic-del {
   position: absolute;
   top: 4px;
   right: 4px;
   width: 20px;
   height: 20px;
   line-height: 18px;
   text-align: center;
   background: rgba(229,57,53,0.9);
   color: #fff;
   border-radius: 50%;
   font-size: 14px;
   text-decoration: none;
   z-index: 2;
   transition: background 0.2s;
}
.pic-del:hover {
   background: rgba(229,57,53,1);
}

/* 富文本编辑器 */
.editor-container {
   border: 1px solid #dcdfe6;
   border-radius: 6px;
   overflow: hidden;
}

/* 底部按钮 */
.form-footer {
   display: flex;
   justify-content: center;
   gap: 20px;
   padding: 20px 0 40px;
}
.form-footer a {
   display: inline-block;
   width: 120px;
   height: 42px;
   line-height: 42px;
   text-align: center;
   border-radius: 8px;
   font-size: 15px;
   font-weight: 500;
   text-decoration: none;
   transition: all 0.3s;
}
.btn-cancel {
   background: #fff;
   color: #666;
   border: 1px solid #dcdfe6;
}
.btn-cancel:hover {
   color: #e57834;
   border-color: #e57834;
   background: #fff8f4;
}
.btn-submit {
   background: linear-gradient(135deg, #e57834, #d06520);
   color: #fff;
   border: none;
   box-shadow: 0 4px 12px rgba(229,120,52,0.3);
}
.btn-submit:hover {
   background: linear-gradient(135deg, #f08a48, #e57834);
   box-shadow: 0 6px 16px rgba(229,120,52,0.4);
   transform: translateY(-1px);
}

/* 图片全屏预览 */
#showimgbox {
    width: 100%;
    height: 100%;
    position: fixed;
    z-index: 50;
    top: 0;
    left: 0;
    background-color: rgba(0,0,0,0.7);
}
#showimgbox img {
    position: absolute;
    top: 50%;
    left: 50%;
    border-radius: 6px;
}
#showimgbox a {
    width: auto;
    height: 40px;
    position: absolute;
    top: 10px;
    right: 10px;
    display: block;
    color: #fff;
    text-align: center;
    line-height: 40px;
    text-decoration: none;
    background: rgba(0,0,0,0.4);
    padding: 0 16px;
    border-radius: 20px;
    font-size: 14px;
    transition: background 0.3s;
}
#showimgbox a:hover {
    background: rgba(0,0,0,0.6);
}
</style>